import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  useTheme,
  Typography,
  AppBar,
  Toolbar,
  Grid,
  Button,
} from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import {
  getGradingDetails,
  getSubjectScoresModeration,
} from '../../../../Utils/apiServices';
import KenLoader from '../../../../Components/KenLoader';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  main: {
    padding: '32px 0px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: ' ',
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        {children}
        <TableCell>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {/* {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} */}
          </IconButton>
        </TableCell>
      </TableRow>
      {isExpanded && (
        <TableRow style={{ backgroundColor: 'aliceblue' }}>
          {/* {expandComponent} */}
        </TableRow>
      )}
    </>
  );
};

const ModerationStudentList = () => {
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);

  const [rows2, setRows2] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [top3Student, setTop3Student] = useState([]);

  const [previous, setPrevious] = useState({});

  const classes = useStyles();
  const paramId = useParams();

  /* table pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    // setRows(newRows);
  };
  const getSubjectScoresModerationData = () => {
    setLoading(true);
    getSubjectScoresModeration('a0C1y000001XfNcEAK')
      .then((res) => {
        setLoading(false);
        const numDescending = [...res].sort(
          (a, b) =>
            b.marksObtained - a.marksObtained &&
            b.MidtermMarks - a.MidtermMarks &&
            b.EndtermMarks - a.EndtermMarks
        );
        const top3Students = [];
        numDescending.slice(0, 3).map((i) => {
          console.log('iiiii', i);
          top3Students.push({
            id: i.studentId,
            studentName: i.studentName,
            finalMidtermMarks: i.MidtermMarks,
            finalEndTermMarks: i.EndtermMarks,
            finalTotalMarks: i.marksObtained,
            calculatedGrade: i.calculatedLetterGrade,
            penalties: i.penalty,
            finalGrade: i.finalLetterGrade,
            quiz1: 20,
            quiz2: 15,
            project1: 10,
            project2: 10,
            assignment1: 15,
            assignment2: 14,
          });
        });
        setRows(top3Students);

        const bottomThreeStudent = [];
        numDescending.slice(-3).map((i) => {
          console.log('iiiii', i);
          bottomThreeStudent.push({
            id: i.studentId,
            studentName: i.studentName,
            finalMidtermMarks: i.MidtermMarks,
            finalEndTermMarks: i.EndtermMarks,
            finalTotalMarks: i.marksObtained,
            calculatedGrade: i.calculatedLetterGrade,
            penalties: i.penalty,
            finalGrade: i.finalLetterGrade,
            quiz1: 20,
            quiz2: 15,
            project1: 10,
            project2: 10,
            assignment1: 15,
            assignment2: 14,
          });
        });
        setRows1(bottomThreeStudent);
        function middleItem(arr) {
          if (!arr.length) return;

          let mid = arr.length / 2;
          if (arr.length % 2 === 1) {
            mid = Math.floor(mid);
          }
          return [arr[mid - 1], arr[mid], arr[mid + 1]];
        }
        const middleStudent = [];
        middleItem(res).map((i) => {
          middleStudent.push({
            id: i.studentId,
            studentName: i.studentName,
            finalMidtermMarks: i.MidtermMarks,
            finalEndTermMarks: i.EndtermMarks,
            finalTotalMarks: i.marksObtained,
            calculatedGrade: i.calculatedLetterGrade,
            penalties: i.penalty,
            finalGrade: i.finalLetterGrade,
            quiz1: 20,
            quiz2: 15,
            project1: 10,
            project2: 10,
            assignment1: 15,
            assignment2: 14,
          });
        });
        setRows2(middleStudent);
        console.log('jdbfhfdhfih', middleStudent);

        // setRows(topThreeStudent);
        // setRows2(middleThreeStudent);
        // setRows1(bottomThreeStudent);
      })
      .catch((err) => {
        setLoading(false);
        console.log('grading error', err);
      });
  };

  useEffect(() => {
    getSubjectScoresModerationData();
  }, []);

  return (
    <Box className={classes.main}>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Moderation
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button> */}

            {/* <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              to={'#'}
            >
              Save
            </Button> */}
          </Grid>
        </Toolbar>
      </AppBar>
      {loading && <KenLoader />}
      <Box className={`cardlsitbox`}>
        {' '}
        <KenCard elevation={0}>
          {' '}
          <Typography variant="h6" className={classes.title}>
            Top 3 Student{' '}
          </Typography>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  Student list
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Mid Term Exam
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  End Term Exam{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Total Marks Obt
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Calculated Grade
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Penalty
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  Final Grade
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows.length === 0 && (
                <TableCell colSpan={8}>No Record</TableCell>
              )}
              {rows &&
                (rowsPerPage > 0
                  ? rows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : rows
                ).map((row) => {
                  const SetDateFormat = {
                    ...row,
                    examDate: moment(row.dateTimeofExam).format(
                      'YYYY-MM-DD HH:mm'
                    ),
                  };
                  return (
                    // <TableRow className="editableTableRowData" key={row.id}>
                    <ExpandableTableRow
                      key={row.id}
                      expandComponent={
                        <TableCell className="testForCol" colSpan="10">
                          <Table>
                            <TableRow>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 1
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 2
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Project 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Project 2
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Assignment 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Assignment 2
                              </TableCell>
                            </TableRow>

                            <TableBody className="tablebody">
                              <KenGridEditable
                                {...{
                                  row: SetDateFormat,
                                  onChange,
                                  columns: [
                                    {
                                      column_name: 'quiz1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'quiz2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },

                                    // {
                                    //   column_name: 'allocatedTo',
                                    //   is_inline_edit: false,
                                    //   inline_edit_type: 'kenSelect',
                                    //   dropdown: selectOptionsAllocated,
                                    //   label: 'allocatedTo',
                                    //   onChange: handleSelectChangeAllocated,
                                    // },
                                    {
                                      column_name: 'project1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      label: '',
                                    },
                                    {
                                      column_name: 'project2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      // label: 'eligibility_status',
                                      // style: 'red',
                                    },
                                    {
                                      column_name: 'assignment1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'assignment2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                  ],
                                }}
                              />
                            </TableBody>
                          </Table>
                        </TableCell>
                      }
                    >
                      {console.log('rowformeval', row)}
                      <KenGridEditable
                        {...{
                          row: SetDateFormat,
                          onChange,
                          columns: [
                            {
                              column_name: 'studentName',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'StudentList',
                            },

                            {
                              column_name: 'finalMidtermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalMidtermMarks',
                            },
                            {
                              column_name: 'finalEndTermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalEndTermMarks',
                            },
                            {
                              column_name: 'finalTotalMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalTotalMarks',
                            },
                            {
                              column_name: 'calculatedGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'calculatedGrade',
                            },
                            {
                              column_name: 'penalties',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'penalties',
                            },
                            {
                              column_name: 'finalGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'finalGrade ',
                            },
                          ],
                        }}
                      />
                    </ExpandableTableRow>
                  );
                })}
            </TableBody>
          </Table>
          {/* <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={6}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box> */}
        </KenCard>
      </Box>{' '}
      <Box className={`cardlsitbox`}>
        {' '}
        <KenCard elevation={0}>
          {' '}
          <Typography variant="h6" className={classes.title}>
            Middle 3 Student{' '}
          </Typography>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  Student list
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Mid Term Exam
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  End Term Exam{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Total Marks Obt
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Calculated Grade
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Penalty
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  Final Grade
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows2.length === 0 && (
                <TableCell colSpan={8}>No Record</TableCell>
              )}
              {rows2 &&
                (rowsPerPage > 0
                  ? rows2.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : rows2
                ).map((row) => {
                  const SetDateFormat = {
                    ...row,
                    examDate: moment(row.dateTimeofExam).format(
                      'YYYY-MM-DD HH:mm'
                    ),
                  };
                  return (
                    // <TableRow className="editableTableRowData" key={row.id}>
                    <ExpandableTableRow
                      key={row.id}
                      expandComponent={
                        <TableCell className="testForCol" colSpan="10">
                          <Table>
                            <TableRow>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 1
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 2
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Project 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Project 2
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Assignment 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Assignment 2
                              </TableCell>
                            </TableRow>

                            <TableBody className="tablebody">
                              <KenGridEditable
                                {...{
                                  row: SetDateFormat,
                                  onChange,
                                  columns: [
                                    {
                                      column_name: 'quiz1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'quiz2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },

                                    // {
                                    //   column_name: 'allocatedTo',
                                    //   is_inline_edit: false,
                                    //   inline_edit_type: 'kenSelect',
                                    //   dropdown: selectOptionsAllocated,
                                    //   label: 'allocatedTo',
                                    //   onChange: handleSelectChangeAllocated,
                                    // },
                                    {
                                      column_name: 'project1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      label: '',
                                    },
                                    {
                                      column_name: 'project2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      // label: 'eligibility_status',
                                      // style: 'red',
                                    },
                                    {
                                      column_name: 'assignment1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'assignment2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                  ],
                                }}
                              />
                            </TableBody>
                          </Table>
                        </TableCell>
                      }
                    >
                      {console.log('rowformeval', row)}
                      <KenGridEditable
                        {...{
                          row: SetDateFormat,
                          onChange,
                          columns: [
                            {
                              column_name: 'studentName',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'StudentList',
                            },

                            {
                              column_name: 'finalMidtermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalMidtermMarks',
                            },
                            {
                              column_name: 'finalEndTermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalEndTermMarks',
                            },
                            {
                              column_name: 'finalTotalMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalTotalMarks',
                            },
                            {
                              column_name: 'calculatedGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'calculatedGrade',
                            },
                            {
                              column_name: 'penalties',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'penalties',
                            },
                            {
                              column_name: 'finalGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'finalGrade ',
                            },
                          ],
                        }}
                      />
                    </ExpandableTableRow>
                  );
                })}
            </TableBody>
          </Table>
          {/* <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={6}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box> */}
        </KenCard>
      </Box>
      <Box className={`cardlsitbox`}>
        {' '}
        <KenCard elevation={0}>
          {' '}
          <Typography variant="h6" className={classes.title}>
            Bottom 3 Student{' '}
          </Typography>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  Student list
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Mid Term Exam
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  End Term Exam{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Total Marks Obt
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Calculated Grade
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Penalty
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  Final Grade
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows1.length === 0 && (
                <TableCell colSpan={8}>No Record</TableCell>
              )}
              {rows1 &&
                (rowsPerPage > 0
                  ? rows1.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : rows1
                ).map((row) => {
                  const SetDateFormat = {
                    ...row,
                    examDate: moment(row.dateTimeofExam).format(
                      'YYYY-MM-DD HH:mm'
                    ),
                  };
                  return (
                    // <TableRow className="editableTableRowData" key={row.id}>
                    <ExpandableTableRow
                      key={row.id}
                      expandComponent={
                        <TableCell className="testForCol" colSpan="10">
                          <Table>
                            <TableRow>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 1
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Quiz 2
                              </TableCell>

                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Project 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Project 2
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle centerStatusTitle"
                                align="left"
                              >
                                Assignment 1
                              </TableCell>
                              <TableCell
                                className="tableHeaderTitle"
                                align="left"
                              >
                                Assignment 2
                              </TableCell>
                            </TableRow>

                            <TableBody className="tablebody">
                              <KenGridEditable
                                {...{
                                  row: SetDateFormat,
                                  onChange,
                                  columns: [
                                    {
                                      column_name: 'quiz1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'quiz2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },

                                    // {
                                    //   column_name: 'allocatedTo',
                                    //   is_inline_edit: false,
                                    //   inline_edit_type: 'kenSelect',
                                    //   dropdown: selectOptionsAllocated,
                                    //   label: 'allocatedTo',
                                    //   onChange: handleSelectChangeAllocated,
                                    // },
                                    {
                                      column_name: 'project1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      label: '',
                                    },
                                    {
                                      column_name: 'project2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                      // label: 'eligibility_status',
                                      // style: 'red',
                                    },
                                    {
                                      column_name: 'assignment1',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                    {
                                      column_name: 'assignment2',
                                      is_inline_edit: false,
                                      inline_edit_type: '',
                                    },
                                  ],
                                }}
                              />
                            </TableBody>
                          </Table>
                        </TableCell>
                      }
                    >
                      {console.log('rowformeval', row)}
                      <KenGridEditable
                        {...{
                          row: SetDateFormat,
                          onChange,
                          columns: [
                            {
                              column_name: 'studentName',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'StudentList',
                            },

                            {
                              column_name: 'finalMidtermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalMidtermMarks',
                            },
                            {
                              column_name: 'finalEndTermMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalEndTermMarks',
                            },
                            {
                              column_name: 'finalTotalMarks',
                              is_inline_edit: false,
                              inline_edit_type: '',
                              label: 'finalTotalMarks',
                            },
                            {
                              column_name: 'calculatedGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'calculatedGrade',
                            },
                            {
                              column_name: 'penalties',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'penalties',
                            },
                            {
                              column_name: 'finalGrade',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput1',
                              label: 'finalGrade ',
                            },
                          ],
                        }}
                      />
                    </ExpandableTableRow>
                  );
                })}
            </TableBody>
          </Table>
          {/* <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={6}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box> */}
        </KenCard>
      </Box>{' '}
      {/*  ilhs*/}
    </Box>
  );
};

export default ModerationStudentList;
